const ToasterSuccess = () => {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21.5"
        cy="21.5"
        r="19.4024"
        stroke="white"
        strokeWidth="4.19512"
      />
      <path
        d="M11.5352 22.0246L17.8278 28.8416L31.462 14.6831"
        stroke="#FDFDFD"
        strokeWidth="4.19512"
      />
    </svg>
  );
};

export default ToasterSuccess;
